import Axios from "axios";
import { SET_EVALUATION_PARAM_GENERATE, UNSET_EVALUATION_PARAM_GENERATE } from "@/store/mutation-types";

import { getCsQuotationEvalGenerate as getCsQuoatationEvalGenerateApi } from "@/store/api";

// initial state

const state = {
  getCsQuotationEvalGenerate : [],
}

const getters = {
  getCsQuotationEvalGenerate(state){
    return state.getCsQuotationEvalGenerate;
  }
}

const mutations = {
  [SET_EVALUATION_PARAM_GENERATE](state,data){
    state.getCsQuotationEvalGenerate = data;
  },
  [UNSET_EVALUATION_PARAM_GENERATE](state){
    state.getCsQuotationEvalGenerate = [];
  }
}

const actions = {
   getCsQuotationEvalGenerate({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getCsQuoatationEvalGenerateApi, {
        params: {
          rfq_master_id: data.rfq_master_id,
          pur_cs_evaluation_configuration_master_id: data.pur_cs_evaluation_configuration_master_id
        }
      })
        .then(function (response) {
          commit('SET_EVALUATION_PARAM_GENERATE', response.data.data);
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_EVALUATION_PARAM_GENERATE');
          reject(error);
        });
    });
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}